// extracted by mini-css-extract-plugin
export var restrictedWidthButton = "_q3-0";